<template>

    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Requisitions List</h4>
                <p class="subtitle-1">List of purchase Requisitions</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row  align="center">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.purchase_requisition.create)">
                <v-btn
                    color="primary" 
                    block
                    @click="navigateToRequisitions"
                >
                    new requisition
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false" >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            block
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        hide-details="auto"
                                        label="Code"
                                        v-model="searchForm.code"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="handleSubmit">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :loading="loading"
                >
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleClickRow(item)" >
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.orders_count`]="{item}">
                        <div v-if="item.orders_count" class="font-weight-bold">
                            <v-icon v-for="c in item.orders_count" :key="c" :color="item.orders_count > 0 ? 'success' : 'primary' ">mdi-cart</v-icon>
                        </div>
                        <div v-else>
                            <v-icon color="grey lighten-2">mdi-cart</v-icon>
                        </div>
                    </template>
                    <template v-slot:[`item.priority`]="{item}">
                        {{formatPriority(item.priority).name}}
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissions from "./../../data/permissions"
import PStatus from "./../../components/common/PStatus.vue"
import { mapGetters } from 'vuex';
import requisitionAPI from './../../services/purchase/requisition.js';


export default {
    components: {
        PStatus
    },
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Created By", value: "created_by" },
                { text: "Priority", value: "priority" },
                { text: "Orders", value: "orders_count" },
                { text: "State", value: "state" },
            ],
            items: [],
            options: {},
            warehouse_id: null,
            page: 1,
            serverItemsLength: null,
            loading: false,
            searchForm: {
                code: "",
                supplier_id: ""
            },
            permissions 
            
        }
    },
    watch: {
        options: {
            deep: true,
        
            handler() {
                this.list()
            }
        }
    },
    computed: {
        ...mapGetters({
            priorities: "purchase/priority/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        
        list() {
            this.loading = true;
            requisitionAPI.index({...this.options, state: 1, warehouse_id: this.warehouse_id ,...this.searchForm}).then(res => {
                this.items = res.data.data
                this.serverItemsLength = res.data.count
            }).finally(() => {
                this.loading = false
            })
        },
        handleClickRow(item) {
            this.$router.push({name: "Requisition", params: {id: item.id}})
        },
        handleSubmit() {
            this.list()
        },
        formatPriority(priority) {
            return this.priorities.find(each => each.id == priority);
        },
        navigateToRequisitions() {
            this.$router.push({name: "RequisitionCreate"})
        }
        
    },
    created() {
        this.warehouse_id = this.$route.params.warehouseId  
    }
}
</script>

<style>

</style>